import { useEffect, useState } from "react"
import { PrintJson } from "../../../theme/Component/PrintJson";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _AccountHelpDesk, _HelpDesk, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { MyEditor } from "../../../theme/Component/MyEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { toast } from "react-toastify";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const HD001 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const { _procedure, _pocessData, _exportMap, _pushInfo, _pushProps } = configProcedure;

    const _helpDesk = useDataBean(_HelpDesk);
    const _accountHelpDesk = useDataBean(_AccountHelpDesk);
    const { bean, setBean, lista, setLista, handleChange } = _helpDesk;    
    const listaCaso:[] = _accountHelpDesk.lista;
    const account:any = _single.getAccount();
    const [descripcion,setDescripcion] = useState<string>('');

    useEffect(() => {
        if (_pocessData?.Props) {
            setProps(_pocessData?.Props)
        }
        _accountHelpDesk.getLista({ State: 1 }, null);
        setBean({
            Observation:'',
            IDHelpType:0
        })
    }, [configProcedure?._pocessData])

    useEffect(()=>{
        let des = '';
        if(listaCaso.length>0)
        {   
            let obj:any = listaCaso.find((item:any) => item.DataBeanProperties.IDAccountHelpDesk == bean.IDHelpType);
            
            if(obj?.DataBeanProperties)
                 des = obj.DataBeanProperties.Description;

        }
        setDescripcion(des);
    },[bean.IDHelpType])

    const radicarSolicitado=()=>
    {
        if(bean.Observation!='')
            {
                let temp = {...bean};
                temp.IDProcedureImp = _pocessData.IDProcedureImp;
                _HelpDesk.updateCustonBean(temp).then(
                    (resp:any)=>{
                    const help = resp.DataBeanProperties;
                    
                    console.log(help);
                    if(_pushInfo)
                        _pushInfo(_single.jsonToBootstrapTable({
                            Solicitud:temp.Observation,
                            Solicitante:account.EmployeeName,
                            
                    }));
                    if(_pushProps)
                        _pushProps({...help,"Solicitante":account.EmployeeName});
                    if(_exportMap)
                        _exportMap(help);
                })


        }else{
            toast.warning("Por favor deje una descripcion de su solicitud.");
        }
        

    }


    return (
        <div className="row">
            <div className="col-md-12">
                <label>Solicitud</label>
                <textarea rows={6} name="Observation" id="Observation" value={bean.Observation} onChange={handleChange} className="form-control"></textarea>
            </div>
            <div className="col-md-12">
                <label>Clasificación del caso</label>
                <select name="IDHelpType" id="IDHelpType" value={bean.IDHelpType} onChange={handleChange} className="form-select">
                    <option key={_single.getRandomInt()} value={0}>...</option>
                    {listaCaso.map((item:any,index:number)=>{
                        return(
                            <option key={index} value={item.DataBeanProperties.IDAccountHelpDesk}>{item.DataBeanProperties.Name}</option>
                        )
                    })}
                </select>
            </div>
            <div className="col-md-12">

                {descripcion != '' &&
                <p className="p-3">
                    {descripcion}
                </p>
                }
                
            </div>
            <div className="col-md-6">
                <BasicButton icon="" useMargin eventClick={radicarSolicitado}>Solicitar</BasicButton>
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={_procedure} />                 */}
            </div>
        </div>
    )
}